import React from 'react';
import PropTypes from 'prop-types';
import './top-nav-volume.scss';

const TopNavVolume = ({ volumeIsOn, onChange }) => {
    const ariaLabel = `Toggle page audio. Currently ${volumeIsOn ? 'active' : 'inactive'}`;

    return (
        <div className="top-nav-volume">
            <input
                type="checkbox"
                id="volume"
                className="top-nav-volume__checkbox"
                checked={ !!volumeIsOn }
                onChange={ onChange }
                aria-label={ariaLabel}
            />
            <label
                htmlFor="volume"
                className="top-nav-volume__label"
            ></label>
        </div>
    )
}

TopNavVolume.propTypes = {
    volumeIsOn: PropTypes.bool,
    onChange: PropTypes.func.isRequired
}

export default TopNavVolume
